import React from 'react';
import {useDispatch} from 'react-redux';
import Popup from '../../index';
import {
	customFieldDeletionErrorPopup,
} from '../../../../../actions/customFieldsActions';
import Button from '../../../button';
import Icon from '../../../icon';

function CustomFieldDeletionErrorPopup ({data}) {

	const dispatch = useDispatch();

	const close = () => {
		dispatch(customFieldDeletionErrorPopup(null))
	};

	const handleClick = () => {
		dispatch(customFieldDeletionErrorPopup(null));
	};

	return (
		<Popup className="p-4" onClose={close}>
			<h2 className="text-danger"><Icon name="warning" className="text-danger"/> Custom field deletion error</h2>
			{/*<p>Custom field partially deleted - Not deleted from read-only contacts shared from cross domain.</p>*/}
			{
				data.message.includes("Custom field partially deleted")
				?
					<div>
						<p>This custom field is partially deleted, due to the fact some of them belongs to read-only contacts shared from cross domain. You are invited to contact the respective domain owners to delete the custom field on their end to prevent it from being re-created.</p>
						{
							data.parentOwnerEmails && data.parentOwnerEmails.length > 0 && <>
								<p>Owner(s) to contact:</p>
								<ul>
									{
										data.parentOwnerEmails.map(email => (
											<li>{email}</li>
										))
									}
								</ul>
							</>
						}
					</div>
				:
					<p>
						{data.message}
					</p>
			}
			<div className="text-right mt-4">
				<Button onClick={ handleClick } type="button" className="btn-primary">Ok</Button>
			</div>
		</Popup>
	)
}

export default CustomFieldDeletionErrorPopup;
